import React, { Fragment, lazy, Suspense, useEffect, useState, } from 'react';
import { CONS } from '@pomofocus/core';
import ConfigModal from '../features/config/ConfigModal';
const ReportModalContainer = lazy(() => import('../modals/ReportModalContainer'));
const ProfileModalContainer = lazy(() => import('../modals/ProfileModalContainer'));
const TodoListModalContainer = lazy(() => import('../todolist/todolist-modal/TodoListModalContainer'));
const TodoListDocModalContainer = lazy(() => import('../todolist/TodoListDocModalContainer'));
const CrossDeviceAlarmDocModalContainer = lazy(() => import('../modals/CrossDeviceAlarmDocModalContainer'));
const DownloadReportContainer = lazy(() => import('../download/DownloadReportContainer'));
// const AdModalContainer = lazy(() =>
//   import('../modals/AdModalContainer'),
// );
const DeleteUserModalContainer = lazy(() => import('../modals/DeleteUserModalContainer'));
const UpgradeModalContainer = lazy(() => import('../premium/UpgradeModalContainer'));
const SubscriptionModalContainer = lazy(() => import('../premium/SubscriptionModalContainer'));
const WebhookFormModalContainer = lazy(() => import('../modals/WebhookFormModalContainer'));
const WebhookDocModalContainer = lazy(() => import('../modals/WebhookDocModalContainer'));
const ChangeEmailModal = lazy(() => import('../modals/ChangeEmailModal'));
const CreateTemplateModal = lazy(() => import('../template/template-edit/CreateTemplateModal'));
const EditTemplateModal = lazy(() => import('../template/template-edit/EditTemplateModal'));
const HideTasksModalContainer = lazy(() => import('../hide-tasks/HideTasksModalContainer'));
const EditPomodoroCntModal = lazy(() => import('../top/EditPomodoroCntModal'));
const NetworkErrorModal = lazy(() => import('../modals/NetworkErrorModal'));
const StagingGateModal = lazy(() => import('../modals/StagingGateModal'));
const IS_STAGING_HOST = typeof window !== 'undefined' &&
    window.location.hostname === 'stg.pomofocus.io';
// const IS_STAGING_HOST = true;
// import {
//   MODAL_AD,
//   MODAL_CHANGE_EMAIL,
//   MODAL_CREATE_TEMPLATE,
//   MODAL_CROSS_DEVICE_ALARM_DOC,
//   MODAL_DELETE_USER,
//   MODAL_DOWNLOAD_REPORT,
//   MODAL_EDIT_TEMPLATE,
//   MODAL_HIDE_TASKS,
//   MODAL_KEYBORAD_SHORTCUTS,
//   MODAL_PROFILE,
//   MODAL_REPORT,
//   MODAL_SUBSCRIPTION,
//   MODAL_TODO_LIST,
//   MODAL_TODO_LIST_DOC,
//   MODAL_UPGRADE,
//   MODAL_WEBHOOK_DOC,
//   MODAL_WEBHOOK_FORM,
// } from '../../constants';
import { LoadingModal } from '../modals/LodingModal';
import KeyboardShortcutsModal from '../modals/KeyboardShortcutsModal';
const LazyLoadModal = ({ mounted, visible, Component }) => {
    return (mounted && (React.createElement(Suspense, { fallback: visible ? React.createElement(LoadingModal, null) : null },
        React.createElement(Component, null))));
};
export default ({ configObj, visibleModal }) => {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, [null]);
    return (React.createElement(Fragment, null,
        React.createElement(ConfigModal, null),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_REPORT, Component: ReportModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_PROFILE, Component: ProfileModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_TODO_LIST, Component: TodoListModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_UPGRADE, Component: UpgradeModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_TODO_LIST_DOC, Component: TodoListDocModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_CROSS_DEVICE_ALARM_DOC, Component: CrossDeviceAlarmDocModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_DOWNLOAD_REPORT, Component: DownloadReportContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_SUBSCRIPTION, Component: SubscriptionModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_DELETE_USER, Component: DeleteUserModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_WEBHOOK_FORM, Component: WebhookFormModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_WEBHOOK_DOC, Component: WebhookDocModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_CHANGE_EMAIL, Component: ChangeEmailModal }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_CREATE_TEMPLATE, Component: CreateTemplateModal }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_EDIT_TEMPLATE, Component: EditTemplateModal }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_KEYBORAD_SHORTCUTS, Component: KeyboardShortcutsModal }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_HIDE_TASKS, Component: HideTasksModalContainer }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_EDIT_POMODORO_CNT, Component: EditPomodoroCntModal }),
        React.createElement(LazyLoadModal, { mounted: mounted, visible: visibleModal === CONS.MODAL_NETWORK_ERROR, Component: NetworkErrorModal }),
        IS_STAGING_HOST && (React.createElement(LazyLoadModal, { mounted: mounted, visible: IS_STAGING_HOST, Component: StagingGateModal }))));
};
